import React from 'react'
import AAccordion from 'components/AAccordion/AAccordion';
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import styles from "../styles.module.scss";


export const DataCell = ({ label, children }) => {
    return (
        <div className="d-flex flex-column">
            <span className={styles['vendorDetails-label']}>{label} :</span>
            <span className={styles['vendorDetails-value']}>
                <span className="d-flex">
                    {children ?? "NA"}
                </span>
            </span>
        </div>
    );
};


const VendorDetails = ({
    vendorDetails,
    labelFieldMappings
}) => {
    const [expanded, setExpanded] = React.useState(true);

    return (
        <AAccordion expandIcon={<DownArrow />}
            customStyles={{ margin: "20px" }}
            expanded={expanded}
            onChange={(val) => setExpanded(val)}
        >
            <h2 className={`m-0 ${styles['label']}`} >Vendor details</h2>

            <div className={`${styles['student-details-grid']} mt-2`}>
                {labelFieldMappings?.map(el => {
                    const { label, field, renderExtra } = el;
                    const value = vendorDetails?.[field];

                    return (
                        <DataCell
                            label={label}
                            key={field}
                        >
                            {renderExtra
                                ? renderExtra(value)
                                : (value ?? "NA")
                            }
                        </DataCell>
                    );
                })}
            </div>
        </AAccordion>
    );
};


export default VendorDetails